export enum IconSource {
    Vidazoo = 1,
    Material,
}
